module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }